var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/house"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M110 113.75H10C7.95 113.75 6.25 112.05 6.25 110C6.25 107.95 7.95 106.25 10 106.25H110C112.05 106.25 113.75 107.95 113.75 110C113.75 112.05 112.05 113.75 110 113.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M105 49.8999V110H14.75L15 49.8499C15 46.7999 16.4 43.9002 18.85 42.0002L53.85 14.8002C57.45 11.9502 62.55 11.9502 66.15 14.8002L72.85 20L95 37.2001L101.15 42.0002C103.6 43.9002 105 46.7999 105 49.8999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M65 85H55C50.85 85 47.5 88.35 47.5 92.5V110H72.5V92.5C72.5 88.35 69.15 85 65 85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.5 68.75H37.5C34.75 68.75 32.5 66.5 32.5 63.75V56.25C32.5 53.5 34.75 51.25 37.5 51.25H47.5C50.25 51.25 52.5 53.5 52.5 56.25V63.75C52.5 66.5 50.25 68.75 47.5 68.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M82.5 68.75H72.5C69.75 68.75 67.5 66.5 67.5 63.75V56.25C67.5 53.5 69.75 51.25 72.5 51.25H82.5C85.25 51.25 87.5 53.5 87.5 56.25V63.75C87.5 66.5 85.25 68.75 82.5 68.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M95 37.2L72.85 20H89.9C92.65 20 94.9 22.2 94.9 24.95L95 37.2Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse4);
export default __webpack_public_path__ + "static/media/house-4.2dcf696a8c460bbc443eaa1342334447.svg";
export { ForwardRef as ReactComponent };